import { IPortfolioSelection } from "api/getPortfolioSelection";

export const normalizePortfolioSelection = (
  payload: IPortfolioSelection
): IPortfolioSelection => ({
  deals: payload.deals.map((deal) => ({
    ...deal,
    selected: Boolean(deal.selected),
    subjects: deal.subjects.map((subject) => ({
      ...subject,
      selected: Boolean(subject.selected),
    })),
  })),
});
